// components/AudioSubtitlePlayer.jsx
import React, { useEffect, useRef } from "react";
import { useAudioSubtitles } from "../../hooks/useAudioSubtitle";

export default function AudioSubtitlePlayer({
  audioSrc,
  subtitleSrc,
  autoplay = true,
  showControls = false,
  showSkip = true,
  style = {},
  className = "subtitles",
  onAudioComplete,
}) {
  const { audioRef, currentSubtitle } = useAudioSubtitles(audioSrc, subtitleSrc, { autoplay });

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleEnded = () => onAudioComplete?.();
    const handleError = () => console.error("❌ Erreur audio :", audioSrc);

    audio.addEventListener("ended", handleEnded);
    audio.addEventListener("error", handleError);

    return () => {
      audio.removeEventListener("ended", handleEnded);
      audio.removeEventListener("error", handleError);
    };
  }, [audioRef, onAudioComplete, audioSrc]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || !autoplay) return;

    audio.muted = false;
    audio.volume = 1;

    const timeout = setTimeout(() => {
      audio.play().catch((err) => console.warn("⚠️ Impossible de jouer audio :", err));
    }, 100);
    return () => clearTimeout(timeout);
  }, [audioRef, audioSrc, autoplay]);

  return (
    <>
      <audio
        ref={audioRef}
        controls={showControls}
        preload="auto"
        style={{ display: showControls ? "block" : "none" }}
      >
        <source src={audioSrc} type="audio/mp3" />
        Ton navigateur ne supporte pas l'audio HTML5.
      </audio>

      <div
        className={`${className}${!currentSubtitle ? ' subtitles--empty' : ''}`}
        style={{
          ...style,
        }}
      >
        {currentSubtitle}
      </div>
    </>
  );
}
